import { PointGroupFormValues } from '@pages/MapCreateOrEdit/types'

import {
  FIELD_BIND_TYPE_ENUM,
  MAP_DEFAULT_POINT_COLOR,
  MAP_POINT_GROUP_LABEL_ALIGNMENT,
  MAP_POINT_GROUP_LABEL_POSITION,
} from '@constants'

export const getDefaultValues = (): PointGroupFormValues => {
  return {
    code: '',
    title: '',
    objectCode: null,
    coordinateFields: {
      latitudeField: null,
      longitudeField: null,
    },
    pointStyle: {
      color: {
        bindType: { id: FIELD_BIND_TYPE_ENUM.STATIC, label: FIELD_BIND_TYPE_ENUM.STATIC },
        value: MAP_DEFAULT_POINT_COLOR,
      },
    },
    label: {
      bindType: { id: FIELD_BIND_TYPE_ENUM.JS, label: FIELD_BIND_TYPE_ENUM.JS },
      position: { id: MAP_POINT_GROUP_LABEL_POSITION.BOTTOM, label: 'Bottom' },
      align: { id: MAP_POINT_GROUP_LABEL_ALIGNMENT.CENTER, label: 'Center' },
      value: '',
    },
    getDataCommand: null,
  }
}
